import { Suspense } from "react"
import { I18nextProvider } from "react-i18next"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"

import PaydoThemeProvider from "./components/paydo-theme-provider"
import i18n from "./i18n/i18n"
import RoutesList from "./routesList"
import { persistor, store } from "./store"
import { axiosMiddleware } from "./store/enhancers/axios-config"

export default function App() {
	axiosMiddleware(store)

	return (
		<Provider store={store}>
			<PersistGate loading={undefined} persistor={persistor}>
				<I18nextProvider i18n={i18n}>
					<Suspense fallback={<div></div>}>
						<PaydoThemeProvider>
							<RoutesList />
						</PaydoThemeProvider>
					</Suspense>
				</I18nextProvider>
			</PersistGate>
		</Provider>
	)
}
